export const pipe = (...fns) => {
  return (x) => {
    return fns.reduce((v, f) => {
      return f(v)
    }, x)
  }
}
// by Eric Eliott
